import { useMemo, useRef } from "react";
// import the core library.
import ReactEChartsCore from "echarts-for-react/lib/core";
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from "echarts/core";
// Import charts, all with Chart suffix
import {
  LineChart,
  BarChart,
  // PieChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from "echarts/charts";
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  DatasetComponent,
} from "echarts/components";
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from "echarts/renderers";
import logger from "shared/utils/logging";

// Register the required components
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  LineChart,
  LegendComponent,
  CanvasRenderer,
]);

const EBarChart = ({ categories, series, title, legend, yAxis, onItemClick, style = { height: "300px" } }) => {
  // echarts-for-react tears the chart down and rebuilds it whenever the
  // `onEvents` map changes identity, so the map is created once and reads the
  // latest `onItemClick` through a ref. Only series items (slices / bars)
  // count as item clicks, not titles or axis labels.
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;
  const onEvents = useMemo(
    () => ({
      click: (params, chart) => {
        if (params.componentType === "series") onItemClickRef.current?.(params, chart);
      },
    }),
    []
  );

  const option = {
    title: {
      ...{
        text: title,
        subtext: "",
        left: "center",
      },
      ...title,
    },

    tooltip: {
      trigger: "axis",
      axisPointer: {
        // Use axis to trigger tooltip
        type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
      },
    },
    legend: legend ?? {
      show: false,
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
      strokeDashArray: 2,
    },
    yAxis: yAxis ?? {
      type: "value",
    },
    xAxis: {
      type: "category",
      data: categories,
    },
    series: series,
  };

  const onChartReadyCallback = (chart) => {
    logger.log("Chart is ready");
  };

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={option}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={onChartReadyCallback}
      onEvents={onEvents}
      opts={{}}
      style={style}
    />
  );
};

export default EBarChart;
